export default "__VITE_ASSET__KWrxxZwA__"